import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

export default function Footer({ variant = 'default' }) {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={`app-footer app-footer--${variant}`}>
      <div className="footer-content">
        <div className="footer-row">
          <Link to={t('links.privacyPolicy')} className="footer-link">
            {t('footer.privacyPolicy')}
          </Link>
          <span className="footer-separator">•</span>
          <Link to={t('links.termsOfService')} className="footer-link">
            {t('footer.termsOfService')}
          </Link>
          <span className="footer-separator">•</span>
          <Link to={t('links.cookiePolicy')} className="footer-link">
            {t('footer.cookiePolicy')}
          </Link>
          <span className="footer-separator">•</span>
          <span className="footer-copyright">
            © {currentYear} PilotLeague. {t('footer.allRightsReserved')}
          </span>
        </div>
      </div>
    </footer>
  );
}
